import React, { useEffect } from 'react';

import { ToastMessage, useToast } from '../../../hooks/toast';
import { Container } from './styles';

interface ToastProps {
  message: ToastMessage;
  style: object;
}

const icons = {
  info: <span className="mdn-Icon-informacoes mdn-Icon--md" />,
  error: <span className="mdn-Icon-alerta mdn-Icon--md" />,
  success: <span className="mdn-Icon-verificado mdn-Icon--md" />,
};

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 12000);

    return () => {
      clearTimeout(timer);
    };
  }, [removeToast, message.id]);

  return (
    <Container
      key={message.id}
      type={message.type}
      hasDescription={Number(!!message.description)}
      style={style}
    >
      {icons[message.type || 'info']}

      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      <button onClick={() => removeToast(message.id)} type="button">
        <i className="mdn-Icon-fechar mdn-Icon--sm" />
      </button>
    </Container>
  );
};

export default Toast;
